export default __webpack_public_path__ + "static/media/Dr. Rakesh Ramakrishnan .21cfa635.png";